var map = {
	"./sticker_auora_number_0.png": 5207,
	"./sticker_auora_number_1.png": 2481,
	"./sticker_auora_number_2.png": 6985,
	"./sticker_auora_number_3.png": 5321,
	"./sticker_auora_number_4.png": 6644,
	"./sticker_auora_number_5.png": 5811,
	"./sticker_auora_number_6.png": 7844,
	"./sticker_auora_number_7.png": 8405,
	"./sticker_auora_number_8.png": 357,
	"./sticker_auora_number_9.png": 7191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8064;